/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import './home.css'
import {useEffect, useRef, useState} from 'react'

export const homePageStyle: any = {
  signTitle: {
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '36px',
    lineHeight: '100%',
    color: '#4E5552',
  },
  footerHeader: {
    color: '#212121',
    fontSize: 16,
    fontWeight: 700,
    textTransform: 'uppercase',
    paddingBottom: 15,
  },
  footerLink: {
    color: '#212121',
    fontSize: 14,
    paddingLeft: 0,
  },
  copyright: {
    background: '#282E2F',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    padding: '3rem 0 2rem 0',
    lineHeight: '150%',
  },
  navLink: {
    fontWeight: '700',
    fontSize: '1.2rem',
    lineHeight: '100%',
    color: ' #2E3232',
    margin: '2rem 1rem',
  },
  navTrial: {
    background: '#4FE22D',
    border: '1px solid #4FE22D',
    borderRadius: 120,
    color: '#fff',
    padding: '10px 15px',
    fontSize: 14,
  },
}
function HomePage() {
  const partners = [
    {id: 1, name: 'Partner 1', logo: '/media/home/client/1.png'},
    {id: 2, name: 'Partner 2', logo: '/media/home/client/2.png'},
    {id: 3, name: 'Partner 3', logo: '/media/home/client/3.png'},
    {id: 4, name: 'Partner 4', logo: '/media/home/client/4.png'},
    {id: 5, name: 'Partner 5', logo: '/media/home/client/5.png'},
    {id: 6, name: 'Partner 6', logo: '/media/home/client/6.png'},
    // Add more partner objects as needed
  ]

  const [currentPartner, setCurrentPartner] = useState(0)
  const partnerLogoRefs: any = useRef([])
  const [showPopup, setShowPopup] = useState(true)

  const handleClose = () => {
    setShowPopup(false)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPartner((prevPartner) =>
        prevPartner === partners.length - 1 ? 0 : prevPartner + 1
      )
    }, 3000)

    return () => clearInterval(interval)
  }, [])

  const handleMouseEnter = (partnerId: any) => {
    const partnerLogoRef = partnerLogoRefs.current[partnerId]
    if (partnerLogoRef) {
      partnerLogoRef.classList.add('partner-logo-hover')
    }
  }

  const handleMouseLeave = () => {
    partnerLogoRefs.current.forEach((partnerLogoRef: any) => {
      if (partnerLogoRef) {
        partnerLogoRef.classList.remove('partner-logo-hover')
      }
    })
  }

  useEffect(() => {
    partnerLogoRefs.current = partnerLogoRefs.current.slice(0, partners.length)
  }, [partners])

  return (
    <>
      <div className='container'>
        <div className='d-lg-flex justify-space-between w-100 p-5'>
          <div className='flex-grow-0'>
            <img src={toAbsoluteUrl('/media/logos/asteric-white.png')} alt='logo' height={70} />
          </div>
          <div className='flex-grow-1 d-flex  justify-content-end'>
            <Link to={'#'} style={homePageStyle.navLink}>
              Product
            </Link>
            <Link to={'#'} style={homePageStyle.navLink}>
              Feature
            </Link>
            <Link to={'#'} style={homePageStyle.navLink}>
              Pricing
            </Link>
            <Link to={'#'} style={homePageStyle.navLink}>
              Blog
            </Link>
            <Link to={'/auth/login'} style={homePageStyle.navLink}>
              Login
            </Link>
            <div className='d-flex align-items-center' style={{paddingLeft: 15}}>
              <button type='button' style={homePageStyle.navTrial}>
                Start Free Trial
              </button>
            </div>
          </div>
        </div>
        {/* 2nd part */}
        <div className='home_cb54 row' style={{paddingTop: 70}}>
          <div className='col-lg-6'>
            <p>
              Easy way to Manage <br /> your Customers
            </p>
            {/* <img src={toAbsoluteUrl('/media/logos/Vector.png')} alt='logo' width={200} /> */}
            <button
              className='btn mb-5'
              type='button'
              style={{
                borderRadius: 50,
                background: '#4FE22D',
                width: '70%',
                color: '#fff',
                height: 55,
              }}
            >
              Start Free Trial
            </button>
          </div>
          <div className='col-lg-6 text-center d-none d-lg-block'>
            <img src={toAbsoluteUrl('/media/home/Post_COLLAB_23_9.png')} alt='logo' width={600} />
          </div>
        </div>

        {/* 3rd part */}
        <div className='w-100 home_cb55 mt-5'>
          <p className='w-50 pt-3' style={{color: '#5D5D5D', lineHeight: '2rem', minHeight: 120}}>
            It is the fastest and easiest way to manage your customers. Sign up and get instant
            access to exciting tools to support your business
          </p>
        </div>

        {/* 5th part */}
        {/* <div style={{background: '#F6F6F6', padding: '8rem 7rem 3rem 7rem'}}>
          <p>
            <img src={toAbsoluteUrl('/media/custom/sign.png')} alt='sign' height={30} width={200} />
          </p>
          <h1 style={homePageStyle.signTitle}>
            Make Marketing seamless and get the required sales revenue.
          </h1>
          <p style={{fontSize: 20, color: '#262A2B', paddingLeft: '2.5rem'}}>
            All of our features are aimed at improving the sales, marketing and customer experience
            that your business provides, giving them the ability to bring about customer
            satisfaction, loyalty, retention and customer-centricity.
          </p>
          <p className='text-end mt-5' style={{fontSize: '1.5rem'}}>
            Have questions?{' '}
            <Link
              to='#'
              style={{color: '#000', textDecorationLine: 'underline', fontWeight: '700'}}
            >
              Talk to us
            </Link>
          </p>
        </div> */}
      </div>

      {/* Cards */}
      <div className='container pt-5'>
        <div className='row'>
          <div className='col-lg-4 d-flex justify-content-center'>
            <div className='card transparent-card'>
              <img
                src={toAbsoluteUrl('/media/home/topic_landing_page_1400.png')}
                className='card-img-top'
                alt='Image 1'
              />
            </div>
          </div>
          <div className='col-lg-4 d-flex justify-content-center'>
            <div className='card transparent-card'>
              <img
                src={toAbsoluteUrl('/media/home/journey2.png')}
                className='card-img-top'
                alt='Image 2'
              />
            </div>
          </div>
          <div className='col-lg-4 d-flex justify-content-center'>
            <div className='card transparent-card'>
              <img
                src={toAbsoluteUrl('/media/home/plan1.png')}
                className='card-img-top'
                alt='Image 3'
              />
            </div>
          </div>
        </div>
      </div>
      <div className='container my-15 homeCard'>
        <div className='flex-column'>
          <h1 className='title'>Make Marketing seamless and get the required sales revenue.</h1>
          <p className='description'>
            All of our features are aimed at improving the sales, marketing and customer experience
            that your business provides, giving them the ability to bring about customer
            satisfaction, loyalty, retention and customer-centricity.
          </p>
        </div>
      </div>
      {/* client */}
      <div className='container'>
        <h5
          className='mt-20 mb-20'
          style={{
            color: '#504F4F',
            fontWeight: '700',
            textAlign: 'center',
            fontSize: 35,
          }}
        >
          Our Clients
        </h5>
        <div className='partner-carousel'>
          {partners.map((partner) => (
            <img
              key={partner.id}
              ref={(element) => (partnerLogoRefs.current[partner.id] = element)}
              className={`partner-logo ${partner.id === currentPartner ? 'active' : ''}`}
              src={toAbsoluteUrl(partner.logo)}
              alt={partner.name}
              onMouseEnter={() => handleMouseEnter(partner.id)}
              onMouseLeave={handleMouseLeave}
            />
          ))}
        </div>
      </div>
      {/* space */}
      <div style={{minHeight: 150}} />
      {/* improve quality part */}
      <div className='d-flex lime align-items-center' style={{background: '#4EE45D'}}>
        <div className='col-lg-6 left' style={{padding: '3rem'}}>
          <h1>
            Improve the <br />
            quality of <br />
            your service
          </h1>
          <p>
            Implement change management system without any struggle and get your team working with
            optimum speed!{' '}
          </p>
        </div>
        <div
          className='col-lg-6 d-none d-lg-block'
          style={{
            backgroundImage: `url(${toAbsoluteUrl('/media/home/customer-service-skills.png')})`,
            objectFit: 'cover',
            height: '100%',
            // backgroundRepeat: 'no-repeat',
          }}
        ></div>
      </div>
      {/* footer */}
      <div className='col-12 footer' style={{marginTop: '5rem', padding: '0 10rem 5rem'}}>
        <div className='row'>
          {/* Logo/About Company */}
          <div className='col-lg-12 d-flex justify-content-start p-0 mb-10'>
            <img src={toAbsoluteUrl('/media/logos/asteric-white.png')} alt='logo' height={70} />
          </div>
          <div className='col-lg-7'>
            <div className='row'>
              {/* sec-1 */}
              <div className='col-lg-4'>
                <ul className='nav flex-column'>
                  <li className='nav-item pb-3'>
                    <span className='footer-title' style={homePageStyle.footerHeader}>
                      COMPANY
                    </span>
                  </li>
                  <li className='nav-item'>
                    <Link className='nav-link' to='#' style={homePageStyle.footerLink}>
                      How it works
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link className='nav-link' to='#' style={homePageStyle.footerLink}>
                      Pricing
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link className='nav-link' to='#' style={homePageStyle.footerLink}>
                      Demo
                    </Link>
                  </li>
                </ul>
              </div>
              {/* sec-2 */}
              <div className='col-lg-4'>
                <ul className='nav flex-column'>
                  <li className='nav-item pb-3'>
                    <span className='footer-title' style={homePageStyle.footerHeader}>
                      RESOURCES
                    </span>
                  </li>
                  <li className='nav-item'>
                    <Link className='nav-link' to='#' style={homePageStyle.footerLink}>
                      Blog post name goes here
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link className='nav-link' to='#' style={homePageStyle.footerLink}>
                      Blog post name goes here
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link className='nav-link' to='#' style={homePageStyle.footerLink}>
                      Blog post name goes here
                    </Link>
                  </li>
                </ul>
              </div>
              {/* sec-3 */}
              <div className='col-lg-4'>
                <ul className='nav flex-column'>
                  <li className='nav-item pb-3'>
                    <span className='footer-title' style={homePageStyle.footerHeader}>
                      ABOUT
                    </span>
                  </li>
                  <li className='nav-item'>
                    <Link className='nav-link' to='#' style={homePageStyle.footerLink}>
                      Terms & Conditions
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link className='nav-link' to='#' style={homePageStyle.footerLink}>
                      Privacy Policy
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className='col-lg-5 d-lg-flex justify-content-end'>
            {showPopup && (
              <div className='alert-popup-container'>
                <div className='alert-popup'>
                  <div className='alert-header'>
                    <img
                      className='alert-logo'
                      src={toAbsoluteUrl('/media/logos/asteric-white.png')}
                      height={60}
                      alt='Logo'
                    />
                    <button
                      className='btn btn-sm p-1 px-2'
                      onClick={handleClose}
                      style={{background: '#f3f3f3', borderRadius: '50%', position: 'absolute'}}
                    >
                      &times;
                    </button>
                  </div>
                  <div className='alert-body text-center'>
                    <button
                      className='btn btn-sm w-75'
                      style={{background: '#4FE12D', color: '#fff', padding: 10, borderRadius: 85}}
                    >
                      Start Free
                    </button>
                    <p className='mt-2'>
                      Have questions?{' '}
                      <b>
                        <Link to={'/auth/registration'} style={{textDecoration: 'underline'}}>
                          Talk to us
                        </Link>{' '}
                      </b>
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div>
        {/* copyright */}
        <div className='col-12 text-center' style={homePageStyle.copyright}>
          Copyright © 2022 Company name
        </div>
      </div>
    </>
  )
}

export default HomePage
